"use strict";

exports.__esModule = true;
exports["default"] = ControlNext;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ControlNext(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.457 17.387h4.297c.774 0 1.397-.622 1.397-1.393 0-.767-.623-1.395-1.397-1.395l-4.297-.001a1.394 1.394 0 0 0 0 2.789zm25.699.008H10.493a1.405 1.405 0 0 1-1.403-1.401c0-.771.631-1.403 1.403-1.403h16.663l-7.923-7.916a1.397 1.397 0 0 1 0-1.979 1.398 1.398 0 0 1 1.982 0l10.317 10.309c.118.127.225.277.294.455a1.358 1.358 0 0 1 0 1.076c-.07.168-.176.321-.294.452L21.214 27.297a1.39 1.39 0 0 1-.992.418c-.364 0-.722-.14-.989-.418a1.397 1.397 0 0 1 0-1.979l7.923-7.923z"
  }));
}